"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "199w7gr",
  styles: "width:100%;justify-content:center;"
} : {
  name: "199w7gr",
  styles: "width:100%;justify-content:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbldyYXBwZXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVdjIiwiZmlsZSI6IkJ1dHRvbldyYXBwZXIuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB0eXBlIHsgQ29tcG9uZW50VHlwZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG50eXBlIFByb3BzVHlwZSA9IHtcbiAgZml0PzogYm9vbGVhblxufTtcblxuY29uc3QgZml0Q3NzID0gKHByb3BzOiBQcm9wc1R5cGUpID0+IHtcbiAgaWYgKHByb3BzLmZpdCkge1xuICAgIHJldHVybiBjc3NgXG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGA7XG4gIH1cbiAgcmV0dXJuIHVuZGVmaW5lZDtcbn07XG5cbmNvbnN0IEJ1dHRvbldyYXBwZXI6IENvbXBvbmVudFR5cGU8UHJvcHNUeXBlPiA9IHN0eWxlZC5zcGFuYFxuICBhbGlnbi1zZWxmOiBjZW50ZXI7XG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICBmbGV4LXdyYXA6IG5vd3JhcDtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICR7Zml0Q3NzfTtcbmA7XG5cbkJ1dHRvbldyYXBwZXIuZGlzcGxheU5hbWUgPSAnQnV0dG9uV3JhcHBlcic7XG5cbmV4cG9ydCBkZWZhdWx0IEJ1dHRvbldyYXBwZXI7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var fitCss = function fitCss(props) {
  if (props.fit) {
    return _ref;
  }

  return undefined;
};

var ButtonWrapper = (0, _styledBase["default"])("span", {
  target: "e1l6wv1x0",
  label: "ButtonWrapper"
})("align-self:center;display:inline-flex;flex-wrap:nowrap;max-width:100%;position:relative;", fitCss, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbldyYXBwZXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1CMkQiLCJmaWxlIjoiQnV0dG9uV3JhcHBlci5qc3giLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHR5cGUgeyBDb21wb25lbnRUeXBlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbnR5cGUgUHJvcHNUeXBlID0ge1xuICBmaXQ/OiBib29sZWFuXG59O1xuXG5jb25zdCBmaXRDc3MgPSAocHJvcHM6IFByb3BzVHlwZSkgPT4ge1xuICBpZiAocHJvcHMuZml0KSB7XG4gICAgcmV0dXJuIGNzc2BcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYDtcbiAgfVxuICByZXR1cm4gdW5kZWZpbmVkO1xufTtcblxuY29uc3QgQnV0dG9uV3JhcHBlcjogQ29tcG9uZW50VHlwZTxQcm9wc1R5cGU+ID0gc3R5bGVkLnNwYW5gXG4gIGFsaWduLXNlbGY6IGNlbnRlcjtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIGZsZXgtd3JhcDogbm93cmFwO1xuICBtYXgtd2lkdGg6IDEwMCU7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgJHtmaXRDc3N9O1xuYDtcblxuQnV0dG9uV3JhcHBlci5kaXNwbGF5TmFtZSA9ICdCdXR0b25XcmFwcGVyJztcblxuZXhwb3J0IGRlZmF1bHQgQnV0dG9uV3JhcHBlcjtcbiJdfQ== */"));
ButtonWrapper.displayName = 'ButtonWrapper';
var _default = ButtonWrapper;
exports["default"] = _default;